import { useState } from "react";
import { faUserSlash } from "@fortawesome/free-solid-svg-icons";
import { ConfirmDialog } from "@/components/common/Dialog";
import { LoadingOverlay } from "@/components/common/Loading/LoadingOverlay";
import { showSuccessToast } from "@/hooks/use-toast";
import { revokeAllAiUserAccess } from "../api";

export type RevokeAllAiUserAccessDialogProps = {
  userCount: number;
  callBack: () => Promise<void>;
};

export const RevokeAllAiUserAccessDialog = ({ userCount, callBack }: RevokeAllAiUserAccessDialogProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleOpenChange = (open: boolean) => {
    setDialogOpen(open);
    setError(null);
  };

  const handleConfirmRevokeAll = async () => {
    setLoading(true);
    setError(null);
    try {
      await revokeAllAiUserAccess();
      showSuccessToast("Access revoked for all users successfully.");
      setDialogOpen(false);
      await callBack();
    } catch (err) {
      setError("Failed to revoke access for all users.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <LoadingOverlay isVisible={loading} message="Revoking access..." />
      <ConfirmDialog
        open={dialogOpen}
        onOpenChange={handleOpenChange}
        triggerIcon={faUserSlash}
        triggerText="Revoke all"
        triggerVariant="outline"
        title="Revoke all AI access?"
        description={
          <>
            This will revoke AI access for all <strong>{userCount}</strong> currently allow-listed {userCount === 1 ? "user" : "users"}. This cannot be undone.
            {error && <div className="text-red-500 text-sm mt-2">{error}</div>}
          </>
        }
        confirmText="Revoke all"
        cancelText="Cancel"
        loading={loading}
        onConfirm={handleConfirmRevokeAll}
        disableConfirm={loading || userCount === 0}
        disableTrigger={userCount === 0}
      />
    </>
  );
};
